import { Injectable } from '@angular/core';
import { Label } from 'app/app-model/label/label';
import { LabelType } from 'app/app-model/label/label-type';
import { Observable } from 'rxjs';

import { ApiProxyService } from '../modules/shared/services/api-proxy.service';
import { ConfigService } from './config.service';

@Injectable({
    providedIn: 'root'
})
export class LabelService {

    constructor(private apiProxy: ApiProxyService, private configService: ConfigService) { }

    public getLabels(type: LabelType): Observable<Label[]> {
        return this.apiProxy.get<Label[]>(this.configService.apiUrl + 'labels?type=' + LabelType[type]);
    }
}
